 
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Conversation } from '@app-libs/model';
import { ConfigurationClientService } from '../client/configuration-client.service';
import { ApiClient } from '../client/api-client';

@Injectable({
  providedIn: 'root',
})
export class ConversationsApiService extends ApiClient {
  constructor(config: ConfigurationClientService, http: HttpClient) {
    super(config, http);
  }

  override get baseUrl(): string {
    return this.config.getBackendAPIUrl() + '/conversations';
  }

  // Fetch conversations by user ID
  fetchConversationsByUserId(
    userId: string,
    limit = 100,
    offset = 0
  ): Observable<Conversation[]> {
    return this.http.get<Conversation[]>(`${this.baseUrl}/user/${userId}`, {
      params: { limit: limit.toString(), offset: offset.toString() },
    });
  }

  
  // Fetch conversations by user ID
  fetchConversationsForUserWorkspace(
    userId: string,
    limit = 100,
    offset = 0
  ): Observable<Conversation[]> {
    return this.http.get<Conversation[]>(`${this.baseUrl}/workspace/${userId}`, {
      params: { limit: limit.toString(), offset: offset.toString() },
    });
  }

  // Fetch a conversation by ID
  getConversationById(
    conversationId: string,
    loadMessages = false
  ): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${conversationId}`, {
      params: { loadMessages: loadMessages.toString() },
    });
  }

  // Fetch all conversations with assistant names
  fetchAllConversationsWithAssistantNames(
    limit = 100,
    offset = 0
  ): Observable<Conversation[]> {
    return this.http.get<any[]>(`${this.baseUrl}/with-assistants`, {
      params: { limit: limit.toString(), offset: offset.toString() },
    });
  }

  // Create a new conversation
  createConversation(
    conversation: Partial<Conversation>
  ): Observable<Conversation> {
    return this.http.post<Conversation>(`${this.baseUrl}`, conversation);
  }

  // Update a conversation by ID
  updateConversation(
    conversationId: string,
    updateData: any
  ): Observable<boolean> {
    console.debug(
      `Updating conversation222 with ID: ${conversationId}`,
      updateData
    );
    return this.http.put<boolean>(
      `${this.baseUrl}/${conversationId}`,
      updateData
    );
  }

  // Update the last message date for a conversation
  updateLastMessageDate(
    conversationId: number,
    lastMessageDate: Date,
    header?: string
  ): Observable<boolean> {
    return this.http.put<boolean>(
      `${this.baseUrl}/${conversationId}/last-message`,
      {
        lastMessageDate,
        header,
      }
    );
  }

  // Update the thread ID for a conversation
  updateConversationThread(
    conversationId: string,
    threadId: string
  ): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseUrl}/${conversationId}/thread`, {
      threadId,
    });
  }

  // Update the header for a conversation
  updateConversationHeader(
    conversationId: string,
    header: string
  ): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseUrl}/${conversationId}/header`, {
      header,
    });
  }

  // Soft delete a conversation
  softDeleteConversation(conversationId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.baseUrl}/${conversationId}`);
  }
}
